export const environment = {
  production: false,
  projectName: "KIPOINT TEST",
  REST_API_SERVER: "https://kipoint.test.api.testctsolution.it/api",
  URL_CALLBACK: "https://kipoint.test.fe.testctsolution.it",
  googleMapsApiKey: 'AIzaSyCyXPLM-cdTQ8NeJT9grcXclLJZdNmnv6A',
  googleClientId: '467423290222-b3gun4buu8b6agrkucc064rnh6hoqkra.apps.googleusercontent.com',
  appleClientId: '',
  appleRedirectUri: 'https://kipoint.test.fe.testctsolution.it',
}
